export default __webpack_public_path__ + "static/media/ele_sec.6c389e32.png";